<template>
  <div class="content-wrapper" :class="{'cross-content': !$store.state.sharePresentation}">
    <div class="horizontal layout center-justified" style="height: 100%" v-if="checkShowContent">
      <VotingIdeasContent />
    </div>
    <CanvasQuestionImage
      v-show="slideActive.showQuestionImage && slideActive.image"
      @imageLoaded="isLoading = false"
      :isLoading="isLoading"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import VotingIdeasContent from '@/components/presentations/contents/VotingIdeasContent.vue'
import VotingIdeasContentContainer from '@/containers/voting-ideas/VotingIdeasContentContainer'
import CanvasQuestionImage from '@/components-v2/presentation-editor/middle/CanvasQuestionImage.vue'

// utils & services

export default {
  components: {
    VotingIdeasContent: VotingIdeasContentContainer(VotingIdeasContent),
    CanvasQuestionImage,
  },
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
    }),
    checkShowContent() {
      let show = true
      if (this.$store.state.slideActive.showQuestionImage && this.$store.state.slideActive.image) {
        show = false
      }
      return show
    },
  },
  mounted() {
    this.$store.state.showQnaSession = false
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.content-wrapper {
  width: 100%;
  height: 100%;
  &.cross-content {
    &::v-deep text:hover {
      text-decoration: line-through;
      cursor: pointer;
    }
  }
}
</style>
